export const HighlightComments = (data) => {

    const regex = /(Comments:)([\s\S]*?)(?=<br\s*\/>\s*<br\s*\/>\s*<br\s*\/>\s*((\d{2}\s[A-Z]{3}\s\d{4}\s\d{2}:\d{2}:\d{2}\s(?:AM|PM))|\s*))/gm;

    const updatedContent = data.replace(regex, (match, commentsLabel, commentText) => {

        const cleanedComment = commentText.replace(/<br\s*\/?>/gi, '').trim();

        return `
        <div class="comments-row">
            <span class='comments-label'>${commentsLabel}</span>
            <span class='highlighted-comment'>${cleanedComment}</span>
        </div>
        `;
    });

    return updatedContent;
}